import Modal from 'react-modal';
import { useEffect, useState } from 'react';
import { changeDisable, customAdaptativeModal, customFullModal, showMessageError, getPermission, maskSN, validateEmail, validatePassword, viewItem, viewLogOperation } from '../../../classes/functions';
import './users.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FaArrowAltCircleLeft, FaCog } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import ListLog from '../../../components/ListLog/index.js';
import InputWithLabel from '../../../components/Inputs/InputWithLabel.js';
import SelectWithLabel from '../../../components/Select/selectWithLabel.js';

export default function Users() {
    const { option, id } = useParams();
    const history = useHistory();
    const [view, setView] = useState(false);
    const [carrying, setCarrying] = useState(true);
    const [companiesSelectedByUsers, setCompaniesSelectedByUsers] = useState([]);
    const [listPerfis, setListPerfis] = useState([]);
    const [rows_log, setRowsLog] = useState([]);
    const [view_log, setViewLog] = useState({});
    const [view_old_log, setViewOldLog] = useState({});
    const [modalViewLog, setModalViewLog] = useState(false);
    const [inputsValues, setInputsValues] = useState({
        nome: "",
        login: "",
        usuario: "",
        perfil: "",
        senha: "",
        confirmaSenha: "",
        ativo: "",
        ad: "",
        empresas: []
    });

    function validForm(data) {
        let password;
        if (id && (inputsValues.senha === '')) {
            password = true;
        } else {
            password = validatePassword(inputsValues.senha, inputsValues.confirmaSenha);
        }

        if (!validateEmail(inputsValues.usuario)) {
            toast.error('E-mail inválido!');
            return false;
        } else if (password !== true) {
            toast.error(password);
            return false;
        }

        if (!((inputsValues.ativo !== '') && (inputsValues.nome !== '') && (inputsValues.usuarios !== '') && (inputsValues.perfil !== ''))) {
            toast.error('Preencha todos os campos com * antes de salvar.');
            return false;
        }

        let empresa = false;

        inputsValues.empresas.map((element) => {
            if (element.checked === true) {
                empresa = true;
            }
        });

        if (!empresa) {
            toast.error('Preencha todos os campos com * antes de salvar.');
            return false;
        }

        return true;
    }

    function save(e) {
        setCarrying(true);
        e.preventDefault();

        inputsValues.empresas = inputsValues?.empresas.filter((company) => company.checked);

        const data = {
            row: inputsValues
        }

        if (!validForm(data)) {
            setCarrying(false);
            return false;
        }

        delete inputsValues.confirmaSenha;

        if (id) {
            data.row.id = id;

            api.put("/api/users/put", data)
                .then(() => {
                    toast.success('Registro atualizado com sucesso.');
                    history.push('/users');
                }
                ).catch((error) => {
                    setCarrying(false);
                    showMessageError(error.response.data);
                });
        } else {
            api.post("/api/users/post", data)
                .then(() => {
                    toast.success('Registro inserido com sucesso.');
                    history.push('/users');
                }
                ).catch((error) => {
                    setCarrying(false);
                    showMessageError(error.response.data);
                });
        }
    }

    function getOne(id, option) {
        api.get(`/api/users/getList?id=${id}`)
            .then((response) => {
                setInputsValues((prevState) => ({...prevState,
                    ativo: response?.data?.row?.ativo, 
                    ad: response?.data?.row?.ad, 
                    nome: response?.data?.row?.nome, 
                    login: response?.data?.row?.login, 
                    usuario: response?.data?.row?.usuario,
                    perfil: response?.data?.row?.perfil,
                }));

                let IdOfSelectedCompanies = [];
                
                response?.data?.row?.empresas.map((company) => {
                    IdOfSelectedCompanies.push(parseInt(company.id));
                });

                setCompaniesSelectedByUsers(IdOfSelectedCompanies);
                
                setRowsLog(response?.data?.historic);
            }
            ).catch((error) => {
                showMessageError(error.response.data);
            });

        setView(changeDisable(option));
    }

    function cancel() {
        history.push('/users');
    }

    function closeModal() {
        setModalViewLog(false);
    }

    function changeCompanies(e) {
        let aux_companies = [];
        inputsValues.empresas.forEach((element) => {
            if (element.id == e.target.value) {
                element.checked = !element.checked;
            }

            aux_companies.push(element);
        });

        setInputsValues((prevState) => ({...prevState, empresas: aux_companies}));
    }

    function getData() {
        api.get("/api/users/getDataPage")
            .then((response) => {
                setListPerfis(response.data.permissoes);
                setInputsValues((prevState) => ({...prevState, empresas: response.data.empresas}));
                setCarrying(false);
            }).catch((error) => {
                showMessageError(error.response.data);
                setCarrying(false);
            });
    }

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        if(id && option){
            getOne(id, option);
        }
    }, [id, option]);

    return (
        <div>
            <Header />
            <Division />
            <Lateral />
            <ReactTooltip />

            {carrying && <div className="content">
                <div className="divCarrying">
                    <span>Carregando..</span>
                    <FaCog icon="spinner" className="spinner" />
                </div>
            </div>}
            {!carrying && <div className="content">
                <Title name="Cadastro de Usuários">
                    <Link to="/users">
                        <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
                    </Link>
                </Title>
                <div className="container">
                    <form className="form-profile customers">
                        <div className="containerGroupData">
                            <h2>Dados Cadastrais</h2>
                            <hr></hr>
                            <div className="form">
                                <InputWithLabel label="Nome" name="nome" isRequired={true} type="text" state={inputsValues.nome} setState={setInputsValues} disabled={view} />
                                <InputWithLabel label="Login" name="login" isRequired={true} type="text" state={inputsValues.login} setState={setInputsValues} disabled={view} />
                                <InputWithLabel label="E-mail" name="usuario" isRequired={true} type="text" state={inputsValues.usuario} setState={setInputsValues} disabled={view} />
                                <SelectWithLabel label="Perfil" name="perfil" isRequired={true} state={inputsValues.perfil} setState={setInputsValues} disabled={view} optionsList={listPerfis} optionPropertyToShow={"nome"} />
                                <InputWithLabel label="Senha" name="senha" isRequired={true} type="password" state={inputsValues.senha} setState={setInputsValues} disabled={view} />
                                <InputWithLabel label="Confirmar Senha" name="confirmaSenha" isRequired={true} type="password" state={inputsValues.confirmaSenha} setState={setInputsValues} disabled={view} />
                                <SelectWithLabel label="Ativo" name="ativo" isRequired={true} state={inputsValues.ativo} setState={setInputsValues} disabled={view} isBoolean={true} optionsList={["S", "N"]} />
                                <SelectWithLabel label="Usuário AD" name="ad" isRequired={true} state={inputsValues.ad} setState={setInputsValues} disabled={view} isBoolean={true} optionsList={["S", "N"]} />
                            </div>
                        </div>
                        <br />
                        <div className="containerGroupData">
                            <h2>Empresas&nbsp;<label className="required">*</label></h2>
                            <hr></hr>
                            <div className="divGroup">
                                <div className="formDivList">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Nome</th>
                                                <th scope="col">Razão Social</th>
                                                <th scope="col">Cidade</th>
                                                <th scope="col">Estado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {inputsValues?.empresas?.map((item, index) => {
                                                companiesSelectedByUsers?.map((companiesSelectedByUser) => {
                                                    if(parseInt(item.id) === companiesSelectedByUser){
                                                        item.checked = true;
                                                    }
                                                });

                                                return (
                                                    <tr key={index}>
                                                        <td data-label="#">
                                                            <input type="checkbox" checked={item?.checked} value={item?.id}
                                                                onChange={changeCompanies} />
                                                        </td>
                                                        <td data-label="Nome Fantasia">{item?.nome_fantasia}</td>
                                                        <td data-label="Razão Social">{item?.razao_social}</td>
                                                        <td data-label="Cidade">{item?.cidade}</td>
                                                        <td data-label="Estado">{item?.estado}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <br />
                        {!view && <div className="formDiv">
                            {getPermission('CADASTROS - USUARIOS - CADASTRO') &&
                                <button type='button' className="buttonSubmit" onClick={save}
                                    disabled={view}>Salvar</button>}
                            <button type="button" className="buttonCancel" onClick={cancel} disabled={view}>Cancelar
                            </button>
                        </div>}
                    </form>
                </div>

                <ListLog listItems={rows_log} setViewLog={setViewLog} setViewOldLog={setViewOldLog} setModalViewLog={setModalViewLog}></ListLog>
            </div>}

            <Modal
                isOpen={modalViewLog}
                onRequestClose={closeModal}
                style={customFullModal}
                contentLabel="Origem"
                ariaHideApp={false}
                keepMounted
            >
                <div className="body-modal">
                    <div className="divGroup">
                        <h2>Log - {viewLogOperation(view_log.operacao)}</h2>
                    </div>
                    <div className="divGroup">
                        <h3>Usuário {view_log.user}</h3>
                    </div>
                    <div className="divGroup">
                        <div className="formDiv">
                            <table>
                                <thead>
                                    <th>Campo</th>
                                    {view_old_log?.data && <th>Valor em {view_old_log?.data} - {view_old_log.hora}</th>}
                                    <th>Valor em {view_log.data} - {view_log.hora}</th>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Nome</td>
                                        {view_old_log.data && <td>{view_old_log.dados?.row?.nome}</td>}
                                        <td>{view_log.dados?.row?.nome}</td>
                                    </tr>
                                    <tr>
                                        <td>Sobrenome</td>
                                        {view_old_log.data && <td>{view_old_log.dados?.row?.sobrenome}</td>}
                                        <td>{view_log.dados?.row?.sobrenome}</td>
                                    </tr>
                                    <tr>
                                        <td>Login</td>
                                        {view_old_log.data && <td>{view_old_log.dados?.row?.login}</td>}
                                        <td>{view_log.dados?.row?.login}</td>
                                    </tr>
                                    <tr>
                                        <td>Usuario</td>
                                        {view_old_log.data && <td>{view_old_log.dados?.row?.usuario}</td>}
                                        <td>{view_log.dados?.row?.usuario}</td>
                                    </tr>
                                    <tr>
                                        <td>Perfil</td>
                                        {view_old_log.data && <td>{viewItem(listPerfis, view_old_log.dados?.row?.perfil)}</td>}
                                        <td>{viewItem(listPerfis, view_log.dados?.row?.perfil)}</td>
                                    </tr>
                                    <tr>
                                        <td>Ativo</td>
                                        {view_old_log.data && <td>{maskSN(view_old_log.dados?.row?.ativo)}</td>}
                                        <td>{maskSN(view_log.dados?.row?.ativo)}</td>
                                    </tr>
                                    <tr>
                                        <td>Login AD</td>
                                        {view_old_log.data && <td>{maskSN(view_old_log.dados?.row?.ad)}</td>}
                                        <td>{maskSN(view_log.dados?.row?.ad)}</td>
                                    </tr>
                                </tbody>
                            </table>
                            {(view_log?.dados?.companies.length > 0 || view_old_log?.dados?.companies.length > 0) && <h3>Empresas</h3>}
                            <div className="divGroup">
                                {(view_old_log?.dados?.companies.length) > 0 && <div className="formDiv">
                                    <table>
                                        <thead>
                                            <th>Habilitado para</th>
                                        </thead>
                                        <tbody>
                                            {view_old_log?.dados?.companies.map((item, index) => {
                                                return (
                                                    <tr>
                                                        <td>{item.nome_fantasia}</td>
                                                    </tr>
                                                )
                                            })}
                                            {view_old_log?.dados?.companies.length == 0 && <tr>
                                                <td colSpan={4}>&nbsp;</td>
                                            </tr>}
                                        </tbody>
                                    </table>
                                </div>}
                                <div className="formDiv">
                                    {(view_log?.dados?.companies.length > 0 || view_old_log?.dados?.companies.length > 0) && <table>
                                        <thead>
                                            <th>Habilitado para</th>
                                        </thead>
                                        <tbody>
                                            {view_log?.dados?.companies.map((item, index) => {
                                                return (
                                                    <tr>
                                                        <td>{item.nome_fantasia}</td>
                                                    </tr>
                                                )
                                            })}
                                            {view_log?.dados?.companies.length == 0 && <tr>
                                                <td colSpan={4}>&nbsp;</td>
                                            </tr>}
                                        </tbody>
                                    </table>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="formDiv">
                        <button type="button" className="buttonCancel" onClick={closeModal} disabled={view}>Fechar</button>
                    </div>
                </div>
            </Modal>
        </div>

    )
}